"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
// TODO continue working on input default style + focus blur behavior....
function Input(_a) {
    var id = _a.id, className = _a.className, onTextChange = _a.onTextChange, placeholder = _a.placeholder, value = _a.value, _b = _a.type, type = _b === void 0 ? 'text' : _b, inputRef = _a.inputRef;
    return (react_1.default.createElement("input", { value: value, onChange: function (event) {
            onTextChange(event.target.value);
        }, type: type, id: id, className: className, placeholder: placeholder, ref: inputRef }));
}
exports.default = Input;
